import { useIntl } from 'react-intl'

export function getYearsSelection() {
    return getRange(new Date().getFullYear(), 20).map(year => ({ value: year, label: year }))
}

export function getMonthsSelection() {
    return getRange(1, 12).map(month => ({ value: month, label: month }))
}

function getRange(from, count) {
    return Array(count)
        .fill()
        .map((_, index) => from + index)
}

// https://stackoverflow.com/a/19138852/7060818
export function detectCardType(number) {
    const re = {
        VISA: /^4[0-9]{12}(?:[0-9]{3})?$/,
        MasterCard: /^5[1-5][0-9]{14}$/,
        'American Express': /^3[47][0-9]{13}$/,

        // for these we do not have icons
        electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
        maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
        dankort: /^(5019)\d+$/,
        interpayment: /^(636)\d+$/,
        unionpay: /^(62|88)\d+$/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
    }

    for (const key in re) if (re[key].test(number)) return key
}

export const maskCardNumber = cardNumber =>
    cardNumber
        .replace(/\d(?=\d{4})/g, 'x')
        .replace(/(.{4})/g, '$1-')
        .slice(0, -1)

export const formatExpiryDate = (expiryMonth, expiryYear) => {
    const formattedMonth = expiryMonth.toString().padStart(2, '0')
    const formattedYear = expiryYear.toString().slice(-2)
    return `${formattedMonth}${formattedYear}`
}

export const throwTokenResponseError = () => {
    const intl = useIntl()
    const generalErrorMessage = intl.formatMessage({ id: 'credit.card.token.error' })
    throw new Error(generalErrorMessage)
}

export const isCreateTokenResponseOk = response => {
    if (!response.ok) throwTokenResponseError()
    return response
}
